"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const routes_1 = require("@/enums/routes");
const questions = require('./../../static/data/questions.json');
const countries = require('./../../static/data/countries.json');
const state = (0, vue_1.reactive)({
    router: {
        current: routes_1.Routes.HOME,
        props: {
            questionId: 0
        }
    },
    portalType: null,
    userName: '',
    questions: questions.config,
    countries: countries.countries,
    results: [],
    isLoggedIn: false,
    preferredPortalType: null
});
exports.default = state;
